var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.inspectionReportItem.responded)?_c('span',[_vm._v(" "+_vm._s(_setup.formattedValue)+" ")]):_c('span',[_vm._v(" "+_vm._s(_setup.notRespondedText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }